// 共用常量
// local storage key
export const LOCAL_STORAGE_KEY = 'TLDS_TOC_TOKEN'
export const LOCAL_STORAGE_KEY_NAME = 'TLDS_TOC_USERNAME'


//由页面自己处理的code：2000成功
export const HTTP_PASS_CODE=['2000']

//针对 c 端的基础 url
export const TOC_BASE_URL = process.env.VUE_APP_TOC_BASE_URL + '/'

// CRM接口路径
export const BASE_URL = process.env.VUE_APP_BASE_URL + '/wnl/'
// 神农接口路径
export const SN_BASE_URL = process.env.VUE_APP_SN_BASE_URL + '/sn-video/'
// 新看点接口路径
export const NV_BASE_URL = process.env.VUE_APP_NEW_VIDEO_BASE_URL + '/new-video/'

// 天气接口
export const WEATHER_BASE_URL = process.env.VUE_APP_SN_BASE_URL + ':8094/weather/'

// 活动接口JOB_BASE_URL
export const ACTIVITY_BASE_URL = process.env.VUE_APP_SN_BASE_URL + ':9094/activity/'
// 活动接口
//export const JOB_BASE_URL = process.env.VUE_APP_SN_BASE_URL + ':9095/job/'
export const JOB_BASE_URL = process.env.VUE_APP_SN_BASE_URL + ':9099/union-job/'
// 记账本接口
export const BOOK_BASE_URL = process.env.VUE_APP_SN_BASE_URL + ':8095/cashbook/'

// 上传文件地址
export const UPLOAD_URL = BASE_URL + 'uploadFile'

// 导出文件地址
export const DOWNLOAD_URL = BASE_URL + 'outExcel'

// keepAlive Views path
export const KEEP_ALIVE_VIEWS = []

// 统计开始时间
export const STATISTICS_START_TIME = '2021/04/01 00:00:00'

//广告位
export const ADVERT_TYPES=[{name:'开屏',value:'splash'},{name:'插屏',value:'table'},{name:'信息流',value:'template'}]

//外链类型
export const LINK_TYPES=[{name:'h5',value:'h5'},{name:'app',value:'app'},{name:'h5_no_share',value:'h5_no_share'},
{name:'deeplink',value:'deeplink'},{name:'download',value:'download'},{name:'91游戏',value:'91game'},{name:'任务墙',value:'taskwall'},
{name:'语音红包',value:'voicered'}]
